__turbopack_context__.v({
  "compact": "styles-module-scss-module__A9sizq__compact",
  "highlighted": "styles-module-scss-module__A9sizq__highlighted",
  "imageSearchBox": "styles-module-scss-module__A9sizq__imageSearchBox",
  "imageSearchIcon": "styles-module-scss-module__A9sizq__imageSearchIcon",
  "pillInput": "styles-module-scss-module__A9sizq__pillInput",
  "pillInputField": "styles-module-scss-module__A9sizq__pillInputField",
  "pillsInputField": "styles-module-scss-module__A9sizq__pillsInputField",
  "searchBox": "styles-module-scss-module__A9sizq__searchBox",
  "searchText": "styles-module-scss-module__A9sizq__searchText",
  "suggestionItem": "styles-module-scss-module__A9sizq__suggestionItem",
  "suggestionTag": "styles-module-scss-module__A9sizq__suggestionTag",
  "textSearchIcon": "styles-module-scss-module__A9sizq__textSearchIcon",
  "typewriterOverlay": "styles-module-scss-module__A9sizq__typewriterOverlay",
});
